//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import { checkBreakpoint, defaultBlockProps } from "~/helpers";

export default {
    name: "BowContentStickyMedia",
    props: {
        ...defaultBlockProps,

        isActivity: {
            default: false,
            type: Boolean,
        },

        type: {
            default: "dx",
            type: String,
        },
    },

    data: () => ({
        checkBreakpoint: {
            up: {
                md: false,
            },
            down: {
                md: false,
            },
        },
        heightParallax: 0,
        heightSticky: 0,
        image: null,
        indexToShow: 0,
        itemsList: [],
        list: [],
        listPosition: [],
        mutationList: null,
        resizeHeight: null,
        resizeParallax: null,
    }),

    async fetch() {
        if (this.isActivity === false) {
            this.list = [...this.contentList];

            return;
        }

        try {
            const apiResult = await this.$axios.$get(`/posts`, {
                params: {
                    postType: "attivita",
                    culture: this.$store.app.i18n.locale,
                },
            });

            if (
                apiResult.isSuccess === false ||
                apiResult.payload.posts.length === 0
            ) {
                return;
            }

            const posts = apiResult.payload.posts.filter(
                (el) => el.post_status === "publish"
            );

            posts.forEach((item) => {
                let title = null;
                let text = null;
                let image = null;

                if (item.customFields && item.customFields.length > 0) {
                    const titleCf = item.customFields.filter(
                        (el) => el.cf_meta_key === "_titolo"
                    );
                    if (titleCf && titleCf[0] && titleCf[0].cfv_meta_value) {
                        title = titleCf[0].cfv_meta_value;
                    }

                    const textCf = item.customFields.filter(
                        (el) => el.cf_meta_key === "_testo"
                    );
                    if (textCf && textCf[0] && textCf[0].cfv_meta_value) {
                        text = textCf[0].cfv_meta_value;
                    }
                }

                if (
                    item.featuredImage !== null &&
                    typeof item.featuredImage !== "undefined"
                ) {
                    image = {
                        alt: item.featuredImage.post_title,
                        id: item.id,
                        image: {
                            height: 1080,
                            provider: "wordpress",
                            url: item.featuredImage.guid,
                            width: 1920,
                        },
                        type: "image",
                    };
                }

                if (title && text) {
                    this.list.push({
                        id: item.id,
                        title,
                        image,
                        text,
                    });
                }
            });
        } catch (e) {
            console.error(e);
        }
    },

    computed: {
        ...mapState({
            scroll: ({ scroll }) => scroll.scroll,
            pageHeight: ({ scroll }) => scroll.pageHeight,
        }),

        ...mapGetters(["scroll/GET_SCROLL", "scroll/getPageHeight"]),

        getPhoto() {
            let index = 0;

            // Rule to fix not correct execution of following forEach
            const currentScroll = this.scroll.current.y;

            this.listPosition.forEach((item, idx) => {
                if (
                    this.scroll.current.y >= item.top &&
                    this.scroll.current.y <= item.bottom
                ) {
                    index = idx;
                }
            });

            this.updateCurrentIndex(index);

            return this.indexToShow;
        },

        getHeight() {
            return this.heightParallax * 1.75;
        },

        stickyElTop() {
            return `${window.innerHeight / 2 - this.heightSticky / 2}px`;
        },
    },

    watch: {
        itemsList(val, oldVal) {
            if (val && val.length > 0) {
                val.forEach((el, idx) => {
                    const top = el.getBoundingClientRect().top;
                    const bottom = el.getBoundingClientRect().height + top;

                    this.listPosition[idx] = {
                        top:
                            top -
                            el.getBoundingClientRect().height / 2 -
                            window.innerHeight / 2,
                        bottom:
                            bottom +
                            el.getBoundingClientRect().height / 2 +
                            window.innerHeight / 2,
                    };
                });
            }
        },
    },

    mounted() {
        this.checkBreakpoint.up.md = checkBreakpoint.up("md");
        this.checkBreakpoint.down.md = checkBreakpoint.down("md");
        // console.log(this.$refs);
        // console.log(this.$refs.stickyTarget);

        // Get sticky container element
        // const stickyTarget = document.getElementById("stickyTarget");

        // // Define top of sticky element in order to center it vertically
        // if (stickyTarget) {
        //     const stickyEl = stickyTarget.querySelector(".b-sticky");
        //     this.heightSticky = stickyEl.getBoundingClientRect().height;

        //     this.resizeHeight = new ResizeObserver(() => {
        //         this.heightSticky = stickyEl.getBoundingClientRect().height;
        //     });

        //     this.resizeHeight.observe(stickyEl);
        // }
        this.initClientOnlyComp();

        // Get items of list and save their top and bottom
        // It's useful to animate sticky element on scroll
        if (this.$el) {
            this.itemsList = [...this.$el.querySelectorAll(".is-list-item")];

            this.mutationList = new MutationObserver(() => {
                this.itemsList = [
                    ...this.$el.querySelectorAll(".is-list-item"),
                ];
            });

            this.mutationList.observe(this.$el, {
                childList: true,
                subtree: true,
            });

            // Add height to parallax element
            if (this.$el.querySelector(".o-content-sticky-media__parallax")) {
                this.heightParallax = 0;

                [...this.$el.children].forEach((el) => {
                    if (
                        !el.classList.value.includes(
                            "o-content-sticky-media__parallax"
                        )
                    ) {
                        this.heightParallax +=
                            el.getBoundingClientRect().height;
                    }
                });

                if (document.querySelector(".o-content-sticky-media__list")) {
                    this.resizeParallax = new ResizeObserver(() => {
                        let newHeight = 0;

                        [...this.$el.children].forEach((el) => {
                            if (
                                !el.classList.value.includes(
                                    "o-content-sticky-media__parallax"
                                )
                            ) {
                                newHeight += el.getBoundingClientRect().height;
                            }
                        });

                        if (this.heightParallax !== newHeight) {
                            this.heightParallax = newHeight;
                        }
                    });

                    this.resizeParallax.observe(
                        document.querySelector(".o-content-sticky-media__list")
                    );
                }
            }
        }
    },

    methods: {
        updateCurrentIndex(index) {
            this.indexToShow = index;
        },

        initClientOnlyComp(count = 10) {
            this.$nextTick(() => {
                console.groupCollapsed("check Sticky element");

                if (this.$refs.stickyTarget) {
                    const stickyTarget = this.$refs.stickyTarget;
                    console.log("stickyTarget", stickyTarget);

                    const stickyEl = stickyTarget.querySelector(".b-sticky");
                    console.log("stickyEl", stickyEl);
                    this.heightSticky = stickyEl.getBoundingClientRect().height;
                    console.log("this.heightSticky", this.heightSticky);

                    /* eslint-disable */
                    this.resizeHeight = new ResizeObserver(() => {
                        this.heightSticky = stickyEl.getBoundingClientRect().height;
                    });
                    /* eslint-enable */

                    this.resizeHeight.observe(stickyEl);
                } else if (count > 0) {
                    this.initClientOnlyComp(count - 1);
                }

                console.groupEnd();
            });
        },
    },
};
